import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

// eslint-disable-next-line import/no-unused-modules
export const { Link, getPathname, redirect, usePathname, useRouter } =
  createNavigation(routing);
